export default "__VITE_ASSET__8188f71c__"